'use client'
import { useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/shared/api/react-query'
import { GetHypothesesParams } from '@/shared/api/end-points/hypothesis'
import { filterHypothesesSelectors, useFilterHypothesesStore } from '@/features/filter-hypotheses'
import { useRouter } from 'next/navigation'
import { useGetProjectId } from '@/app/slugs'

const useHook = () => {
  const router = useRouter()
  const queryClient = useQueryClient()
  const values = useFilterHypothesesStore(filterHypothesesSelectors.selectStringValues)

  const { projectId } = useGetProjectId()

  const refetch = (params?: GetHypothesesParams) => {
    const queryKey = queryKeys(
      (a, m, p) =>
        a.hypothesis.getHypotheses({
          ...(params || { projectId }),
          ...values,
        }) + m.get,
    )
    queryClient.refetchQueries({ queryKey: [queryKey] })
  }

  return { refetch, router }
}
export default useHook
